import { defineMessages } from 'react-intl';

const messages = defineMessages({
  pageTitle: {
    description: 'Inventory Sources page header',
    defaultMessage: 'Inventory Sources',
    id: 'vA9T20',
  },
  pageHelperText: {
    description: 'Inventory Sources sub header',
    defaultMessage:
      "Your products' Total Available inventory count will display the total count from all the sources you add below. Select which sources you want to include in the Total Available inventory count. <a>Learn more about Total Available Inventory Counts</a>",
    id: 'RwzyzO',
  },
  inventorySyncPageTitle: {
    description: 'Inventory Sync page header',
    defaultMessage: 'Inventory Sync',
    id: 'G80uRT',
  },
  inventorySyncHelperText: {
    description: 'Inventory Sources sub header',
    defaultMessage: 'Let ShipStation sync inventory across all of your stores automatically as you import and ship orders.',
    id: '43g25U',
  },
  loadingLabel: {
    description: 'Inventory Sources loading label',
    defaultMessage: 'Loading...',
    id: 'bf+mwY',
  },
  inventorySourceDropdownLabel: {
    description: 'Inventory Sources dropdown label',
    defaultMessage: 'Inventory Sources',
    id: 'DqSG2h',
  },
  toggleLabel: {
    description: 'Inventory Sources toggle label',
    defaultMessage: 'Add a Source to Total Available...',
    id: 'o2V0a6',
  },
  addAllSources: {
    description: 'Inventory Source Dropdown add all option',
    defaultMessage: 'Add all sources...',
    id: 'sQ2iIV',
  },
  pillBankLabel: {
    description: 'Inventory Source pill bank label',
    defaultMessage: 'Sources Included in Total Available',
    id: '7tjIUj',
  },
  pillBankError: {
    description: 'Inventory Sources no sources errormessages',
    defaultMessage: 'At least one selection from Inventory Sources is required save changes',
    id: 'tvxto8',
  },
  inventorySyncPillBankError: {
    description: 'Inventory Sync page no sources errormessages',
    defaultMessage: 'At least one selection from Inventory Sources is required to determine available quantity',
    id: 'RoFKZv',
  },
  pillBankWarning: {
    description: 'Inventory Sources no sources errormessages',
    defaultMessage: 'If there are no targets, ShipStation will not automatically sync inventory counts',
    id: 'rEaAmn',
  },
  removeAllButtonLink: {
    description: 'Inventory Sources remove all sources button link',
    defaultMessage: 'Remove all sources...',
    id: 'Z7Ajc5',
  },
  confirmationModalHeader: {
    description: 'Inventory Sources confirmation modal header',
    defaultMessage: 'Confirmation',
    id: 'qBV4Vc',
  },
  confirmationModalBodyAdd: {
    description: 'Inventory Sources confirmation modal body message for adding all sources',
    defaultMessage:
      'This will add {count, plural, one {one source} other {all # sources}} to the "Sources Included in Total Available" group. You can manually remove individual sources, or remove all sources using the action following the group.',
    id: '7vRoaf',
  },
  confirmationModalBodyRemove: {
    description: 'Inventory Sources confirmation modal body message for removing all sources',
    defaultMessage:
      'This will clear all selected sources in the "Sources Included in Total Available" group. You will need to add at least one source to save these changes. You can add all sources from the Inventory Sources menu.',
    id: 'jTsQGa',
  },
  continueButton: {
    description: 'Inventory Sources confirmation modal continue button',
    defaultMessage: 'Continue',
    id: 'Vt60R9',
  },
  shipStationInternalInventory: {
    description: 'inventory connection name replacement when connection type is shipengine',
    defaultMessage: 'ShipStation Internal Inventory',
    id: 'ehKou7',
  },
  sourceLabel: {
    description: 'inventory sync page source label',
    defaultMessage: 'Sources',
    id: 'VRZzKj',
  },
  targetLabel: {
    description: 'inventory sync page target label',
    defaultMessage: 'Targets',
    id: 'VHURu/',
  },
  inventorySyncEditButton: {
    description: 'Button to edit inventory sync setup',
    defaultMessage: 'Edit',
    id: 'QNJHOY',
  },
  inventorySyncEditConfiguration: {
    description: 'Header when editing inventory sync configuration',
    defaultMessage: 'Edit Configuration',
    id: 'fauVOd',
  },
  inventorySyncEditConnectionsHelpText1: {
    description: 'Button to edit inventory sync setup',
    defaultMessage: '1. Select your inventory <b>sources</b> to calculate your "In Stock" level in ShipStation.',
    id: 'l+GCU2',
  },
  inventorySyncEditConnectionsHelpText2: {
    description: 'Button to edit inventory sync setup',
    defaultMessage: '2. Select the <b>targets</b> that will receive updated stock levels from the sources.',
    id: 'gl2XVO',
  },
  inventorySyncEditNoSourceSelected: {
    description: 'Label explaining that save configuration button is disabled until a source is selected',
    defaultMessage: 'Select a source to save configuration.',
    id: '+avFLl',
  },
  inventorySyncEditNoTargetSelected: {
    description: 'Label explaining that save configuration button is disabled until a target is selected',
    defaultMessage: 'Select a target to save configuration.',
    id: 'V9fxqf',
  },
  inventorySyncSaveConfigurationBtn: {
    description: 'Button to save new inventory sync configuration',
    defaultMessage: 'Save',
    id: 'Jqr04T',
  },
  inventorySyncCancelEditBtn: {
    description: 'Button to cancel editing inventory sync configuration',
    defaultMessage: 'Cancel',
    id: 'YDf9P7',
  },
  lastSynced: {
    description: 'Label to let the user know of the last time the store inventory was synced',
    defaultMessage: 'Last Synced',
    id: 'YXNx43',
  },
  errorSyncing: {
    description: 'Label to let the user know there was an error syncing the store inventory',
    defaultMessage: 'Syncing error occurred',
    id: 'BZLOpm',
  },
  currentConfiguration: {
    description: 'Current Configuration of the inventory sync connections',
    defaultMessage: 'Current Configuration',
    id: 'TlxTra',
  },
  updateConnectionsSuccessTitle: {
    description: 'Successfully updated connections title',
    defaultMessage: 'Inventory Sync Updated',
    id: '6NxW92',
  },
  updateConnectionsSuccessContent: {
    description: 'Successfully updated connections message',
    defaultMessage: 'Configuration has been updated successfuly.',
    id: 'GYiPZU',
  },
  startSyncSuccessTitle: {
    description: 'Inventory Sync started successfully title',
    defaultMessage: 'Inventory Sync Started',
    id: 'rmNBjI',
  },
  startSyncSuccessContent: {
    description: 'Successfully updated connections message',
    defaultMessage:
      'ShipStation is syncing stock levels for all your products in the background. This can take up to an hour to complete. You can continue working in ShipStation while syncing is in progress.',
    id: '2mOF5J',
  },
  updateConnectionsErrorTitle: {
    description: 'Failed updating connections title',
    defaultMessage: 'We could not sync inventory. Please try again later.',
    id: 'XD7/Fh',
  },
  updateConnectionsErrorContent: {
    description: 'Failed updating connections message',
    defaultMessage:
      'Configuration has been updated successfully, but we could not sync inventory. Please try again later. If this persists, please contact support.',
    id: '/jxQ16',
  },
  updateConnectionsInProgressTitle: {
    description: 'Updating connections in progress title',
    defaultMessage: 'Updating...',
    id: 'aOm2o1',
  },
  updateConnectionsInProgressContent: {
    description: 'Updating connections in progress message',
    defaultMessage: 'Updating Inventory Sync Connections.',
    id: 'UxYVQ0',
  },
  cantSetAutoSyncTitle: {
    description: 'Cannot set automatic sync title',
    defaultMessage: 'Error Setting Automatic Sync',
    id: 'umh9kJ',
  },
  cantSetAutoSyncContent: {
    description: 'Cannot set automatic sync message',
    defaultMessage: 'An error occurred while setting automatic sync. Please try again later. If this persists, please contact support.',
    id: '5nG5Tt',
  },
  manualSyncTitleSuccess: {
    description: 'Sync initiated successfully title',
    defaultMessage: 'New Sync has been initiated.',
    id: '5qzStW',
  },
  manualSyncContentSuccess: {
    description: 'Sync initiated successfully content',
    defaultMessage: 'New Sync has been initiated.',
    id: 'PyTpb3',
  },
  manualSyncTitleFail: {
    description: 'Sync initiated failed title',
    defaultMessage: 'Sync failed to initiate.',
    id: 'y5ZWjN',
  },
  manualSyncContentFail: {
    description: 'Sync initiated failed content',
    defaultMessage: 'Sync failed to initiate.',
    id: 'l6DVoo',
  },
  noConnections: {
    description: 'Messsage explaining how inventory sync will work for first time users.',
    defaultMessage: 'Use Inventory Sync to keep stock levels synchronized across all of your stores.',
    id: '8uvm80',
  },
  setupInventorySyncBtn: {
    description: 'Button to set up inventory sync',
    defaultMessage: 'Set Up Inventory Sync',
    id: 'dJhjRX',
  },
  syncConsolidatedInventoryButton: {
    description: 'Sync inventory counts now',
    defaultMessage: 'Sync Now',
    id: '/zCYPx',
  },
  syncSuccessfullyStartedTitle: {
    description: 'Inventory sync started',
    defaultMessage: 'Inventory Sync Started',
    id: '+ckxdr',
  },
  syncSuccessfullyStarted: {
    description: 'The sync job was successfully scheduled',
    defaultMessage: 'Inventory Sync has started.',
    id: '/tgMZq',
  },
  syncErrorTitle: {
    description: 'Sync error',
    defaultMessage: 'Inventory Sync Error',
    id: 'rUr1qP',
  },
  syncError: {
    description: 'An error occurred that prevented inventory sync from starting',
    defaultMessage: 'An error occurred that prevented inventory sync from starting',
    id: 'ul8cdK',
  },
  inventorySyncConfirmationTitle: {
    description: 'The header of the modal to confirm that you want to save inventory sync settings.',
    defaultMessage: 'Confirm Your Inventory Sync Settings',
    id: '/tahQn',
  },
  inventorySyncConfirmationPrompt: {
    description: 'The prompt to confirm the requirements for saving inventory sync settings.',
    defaultMessage: 'By saving your inventory sync configuration, you agree to the following:',
    id: '30R7JB',
  },
  inventorySyncOverwriteExisting: {
    description: 'Warning that shipstation will overwrite existing inventory in the inventory sync targets.',
    defaultMessage: 'ShipStation will update and overwrite existing inventory counts in your targeted channels',
    id: 'tjURUY',
  },
  inventorySyncConfirmCorrectCounts: {
    description: 'Warning to confirm that your inventory counts in shipstation are correct.',
    defaultMessage: 'You confirm that the inventory counts in ShipStation are correct and up-to-date',
    id: '4raeWk',
  },
  syncInventoryCheckboxLabel: {
    description: 'Checkbox label to confirm the inventory counts should be synced on save.',
    defaultMessage: 'Start syncing my current inventory counts',
    id: 'xZSyk6',
  },
  inventorySyncLearnMoreText: {
    description: 'Link to learn more about inventory sync',
    defaultMessage: 'Learn More about <link>Inventory Sync</link>',
    id: 'tLxh1o',
  },
  saveConfigurationButton: {
    description: 'Button label to save the configuation',
    defaultMessage: 'Save Configuration',
    id: 'Dlv/rH',
  },
  shareFeedbackButton: {
    description: 'Button to open a form to share feedback',
    defaultMessage: 'Share Feedback',
    id: 'qgjAHd',
  },
  initiateManualSync: {
    description: 'Button to initiate a sync',
    defaultMessage: 'Initiate Manual Sync',
    id: 'KXW1WK',
  },
  errorLink: {
    id: '4jSQOD',
    defaultMessage: 'Learn more',
    description: 'Button leading to article',
  },
  automaticSync: {
    id: 'v3lRFa',
    defaultMessage: 'Automatic Sync',
    description: 'Header in tooltip ',
  },
  automaticSyncDescription: {
    defaultMessage: 'Allow ShipStation to sync your stock levels to your selling channels automatically.',
    id: '1OTPHB',
    description: 'Description in tooltip',
  },
  automaticSyncDescription2: {
    defaultMessage:
      'Disabling this feature will stop any automatic sync of stock counts. You can still manually start a sync using the Initiate Manual Sync button.',
    id: 'rLn1bF',
    description: 'Description in tooltip',
  },
  manualJobIsRunning: {
    id: '9obwjY',
    defaultMessage: 'A manual sync job is currently running.',
    description: 'Information on tooltip when manual job is running',
  },
  betaBannerBody: {
    defaultMessage: 'Looking for information or help? See our Inventory Sync <a>FAQ document</a>.',
    id: 'lX6Vkd',
    description: 'Info banner body',
  },
  setupInventoryButtonLabel: {
    defaultMessage: 'Setup Inventory',
    id: 'lSUwbP',
    description: 'A button that describes the action of setting up inventory',
  },
  getInventorySyncButtonLabel: {
    defaultMessage: 'Get Inventory Sync',
    id: 'JtLFXd',
    description: 'A button that describes the action of getting inventory sync',
  },
  getInventorySyncDescriptionText: {
    defaultMessage: 'Add the following add-on to sync your inventory to:',
    id: 'X5aua8',
    description: 'A description of what Inventory Sync does',
  },
  describeSettingUpTargetsToSyncLabel: {
    defaultMessage: 'Add selling channels to sync inventory counts.',
    id: 'ZnqLZ1',
    description: 'A label that describes the action of setting up targets to sync',
  },
  describeChoosingTargetLabel: {
    defaultMessage: 'No targets set. Click Edit to choose some targets.',
    id: 'OZQkxX',
    description: 'A label that describes the action of choosing targets to sync',
  },
  loadingWarehousesLabel: {
    id: 'AbKMRr',
    defaultMessage: 'Loading...',
    description: 'Marketplace warehouses loading label',
  },
  inventorySyncFlowchartAltText: {
    id: 'MnxCr/',
    defaultMessage: 'Inventory Sync Flowchart',
    description: 'Alt text for the inventory sync flowchart image',
  },
});

export default messages;
